#@import GliveBooking.Presenters.Info
#@export GliveBooking.Views.Info

class GliveBooking.Views.Info extends BookingV2.Views.Base

  module: 'glive-booking'

  presenter: GliveBooking.Presenters.Info

  templateName: 'gliveinfo'
